module.exports = __webpack_public_path__ + "img/i_send.e1931d36.svg";